import { render, staticRenderFns } from "./LmInboxIcon.vue?vue&type=template&id=c9788fd6&"
import script from "./LmInboxIcon.vue?vue&type=script&lang=js&"
export * from "./LmInboxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports